import { ITALogo } from "assets";
import { IKnowledgeSection } from "./types";

const internationalTaxation: IKnowledgeSection = {
  key: "internationalTaxation",
  title: "International Taxation",
  // icon: ITALogo,
  color: "#7c3aed",
  // TODO: these are placeholders copied from Income Tax — swap in the real
  // Direct Tax links. Two sections must not share a href, or their cards clash
  // in the "All" view.
  links: [
    {
      title: "Advance Pricing Agreement (APA) Report",
      href: "https://www.incometaxindia.gov.in/advance-pricing-agreement-reports",
    },
    {
      title: "Double Taxation Avoidance Agreements",
      href: "https://www.incometaxindia.gov.in/dtaa",
    },
    {
      title: "DTAA Notifications",
      href: "https://www.incometaxindia.gov.in/double-taxation-avoidance-agreements?doAsUserId=P8dqHo7GMNv%2FXYXPfeJIUA%3D%3D%3FcategoryId%3D40193%3FcategoryId%3D%3FcategoryId%3D%3FcategoryId%3D%3FcategoryId%3D10191473%3FcategoryId%3D%3FcategoryId%3D39787%3FcategoryId%3D40193%3FcategoryId%3D%3FcategoryId%3D%3FcategoryId%3D40193",
    },
    {
      title: "Relevant Provisions for NRI under Income Tax, ​Companies Act, GST & FEMA",
      href: "https://www.incometaxindia.gov.in/relevant-provisions?doAsUserId=P8dqHo7GMNv%2FXYXPfeJIUA%3D%3D%3FcategoryId%3D40193%3FcategoryId%3D%3FcategoryId%3D%3FcategoryId%3D%3FcategoryId%3D10191473%3FcategoryId%3D%3FcategoryId%3D39787%3FcategoryId%3D40193%3FcategoryId%3D%3FcategoryId%3D%3FcategoryId%3D40193",
    },
  ],
};

export default internationalTaxation;
